import axios from 'axios';
import { getParts } from './partService';
import { getInventory } from './inventoryService';
import { getLocations } from './locationService';

// Get dashboard statistics
export const getDashboardStats = async () => {
  try {
    // Fetch parts data
    const parts = await getParts();
    
    // Fetch inventory data
    const inventoryResponse = await getInventory();
    const inventory = inventoryResponse.items || inventoryResponse; // Handle both new and old response format
    
    // Fetch locations data
    const locations = await getLocations();
    
    // Fetch suppliers data
    const token = localStorage.getItem('token');
    const suppliersResponse = await axios.get('/api/suppliers', {
      headers: {
        'x-auth-token': token
      }
    });
    const suppliers = suppliersResponse.data;
    
    // Fetch recent transactions
    const transactionsResponse = await axios.get('/api/inventory/transactions?limit=5', {
      headers: {
        'x-auth-token': token
      }
    });
    // Handle both new and old response formats
    const recentTransactions = transactionsResponse.data.items || transactionsResponse.data;
    
    // Calculate low stock parts
    const lowStockParts = parts.filter(part => {
      if (!part.reorder_point) return false;
      
      // Calculate total quantity across all locations
      const totalQuantity = inventory
        .filter(item => item.part.id === part.id)
        .reduce((sum, item) => sum + item.quantity, 0);
      
      return totalQuantity <= part.reorder_point;
    });
    
    return {
      totalParts: parts.length,
      lowStockParts: lowStockParts.length,
      totalSuppliers: suppliers.length,
      totalLocations: locations.length,
      recentTransactions,
      lowStockPartsList: lowStockParts
    };
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching dashboard data' };
  }
};